import { IAdjustSDK } from './types';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const adjustSDK: IAdjustSDK = __WEB__ ? require('./web').default : require('./native').default;

export default adjustSDK;
